<app-content-container>
  <div class="grid max-w-5xl gap-8 mx-auto md:grid-cols-2">
    <div class="bg-base-100 p-8 rounded-lg shadow-lg">
      <h2 class="text-xl font-bold text-white">Quem pode participar</h2>
      <p class="text-base mt-4" data-testid="mentorship-eligibility">
        As mentorias são para estudantes da Code Dimension. Quem já comprou pelo
        menos um curso ou produto já tem o direito de participar.
      </p>
    </div>

    <div class="bg-base-100 p-8 rounded-lg shadow-lg">
      <h2 class="text-xl font-bold text-white">
        Temas escolhidos pela comunidade
      </h2>
      <p class="text-base mt-4" data-testid="mentorship-community">
        Os temas de cada mês são escolhidos pela comunidade no nosso grupo do
        WhatsApp.
      </p>
    </div>
  </div>
</app-content-container>
